// extracted by mini-css-extract-plugin
export default {"pageContainer":"Terms_pageContainer__v1jpv","updated":"Terms_updated__YGVqP"};